<template>
  <div>
    <!-- 列表页面 -->
    <div class="container" v-if="!showEdit">
      <sticky-top>
        <div class="header">
          <div class="title">中奖名单</div>
          <div class="header-right" v-auth="'搜索用户'">
            <!-- <div class="filter-area">
              <span class="filter-title">搜索</span>
              <el-switch @change="onFilterDisplay" v-model="filterByDisplay"></el-switch>
            </div> -->
            <lin-search @query="onQueryChange" ref="searchKeyword" />
            <span class="back" @click="back">
              <i class="iconfont icon-fanhui"></i> 返回
            </span>
          </div>            
        </div>
        <el-row class="space">
          <el-col :offset="1" :span="2">
            <el-select
                class="type-select"
                filterable
                v-model="lotteryType"
                @change="search">
                <el-option
                  v-for="item in lotteries"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-col>
          <el-col :offset="1" :span="2">
            <el-button type="primary" plain @click="loadXLSX">下载XLSX</el-button>
          </el-col>  
          <el-col :span="2">
            <el-button type="danger" plain @click="clearWinners" :disabled="isProjectPublished">清空中奖</el-button>
          </el-col>
        </el-row>
      </sticky-top>
      <!-- 表格 -->
      <lin-table
        ref="table"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :operate="operate"
        v-loading="loading"></lin-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :background="true"
          :page-size="pageCount"
          :current-page="currentPage"
          v-if="refreshPagination"
          layout="prev, pager, next, jumper"
          :total="total_nums">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import winner from '../../../models/project_winner'
import projectWinner from '../../../models/project_winner'
import LinTable from '@/components/base/table/lin-table'
import LinSearch from '@/components/base/search/lin-search'
import TableImage from '../../../../Common/components/TableImage'
import projectApi from '@/plugins/d_project/models/project' // 新增

export default {
  components: {
    LinTable,
    LinSearch,
    TableImage,
  },
  data() {
    return {
      tableColumn: [        
        { prop: 'code', label: '编号' },
        {
          prop: 'player.head || player.channel_head',
          label: '头像',
          style: {width:"40px",height:"40px"},
          component: TableImage,
        },
        { prop: 'player.nickname', label: '昵称' },
        { prop: 'player.name', label: '名字' },
        { prop: 'player.phone', label: '电话' },
        { prop: 'player.address', label: '地址' },
        { prop: 'win_type', label: '奖品' },
        { prop: 'win_at', label: '中奖时间' },
      ],
      tableData: [],
      operate: [],
      showEdit: false,
      dataID: 1,

      refreshPagination: true, // 页数增加的时候，因为缓存的缘故，需要刷新Pagination组件
      total_nums: 0, // 分组内的总数
      currentPage: 1, // 默认获取第一页的数据
      pageCount: 30, // 每页10条数据
      searchKeyword: '',
      filterByDisplay: false,

      showPreview: false,
      selectedRow: {},
      lotteryType: 0,
      lotteries: [
        {value:0, label:"抽奖"},
        {value:1, label:"收集"},
      ],
      isProjectPublished: false
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = []
    this.checkProjectStatus()
    this.loading = false
  },
  methods: {
    async checkProjectStatus() {
      try {
        // 获取项目ID
        const projectId = this.$store.getters.project
        if (projectId === -1) {
          this.isProjectPublished = false
          return
        }
        // 通过API获取项目详情
        const project = await projectApi.get(projectId)
        this.isProjectPublished = project && project.status === 'published'
      } catch (error) {
        console.error('获取项目状态失败:', error)
      }
    },
    clearWinners() {
      this.$confirm('此操作将清空当前类型的所有中奖信息, 是否继续?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          this.loading = true
          await projectWinner.clear(this.$store.getters.project, this.lotteryType)
          this.$message({
            type: 'success',
            message: '清空成功!'
          })
          this.getDatas() // 清空后刷新数据
        } catch (error) {
          this.$message.error('清空失败: ' + (error.msg || '未知错误'))
        } finally {
          this.loading = false
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        })
      })
    },
    search() {
      this.currentPage = 1
      this.onQueryChange('')
    },
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query ? query.trim() : ''
      this.getDatas()
    },
    onFilterDisplay(value) {
      this.getDatas()
    },
    async getDatas() {
      try {
        this.loading = true
        const data = await winner.gets({project_id: this.$store.getters.project, count: this.pageCount, 
                                        page: this.currentPage, q: this.searchKeyword, 
                                        f_display: this.filterByDisplay, lottery_type: this.lotteryType })
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    loadXLSX() {
        winner.getXLSX({project_id: this.$store.getters.project, count: this.pageCount, 
                                        page: this.currentPage, q: this.searchKeyword, 
                                        f_display: this.filterByDisplay, lottery_type: this.lotteryType })
    },
    back() {
      this.$emit('editClose')
    },
    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
 .type-select {
  >>> .el-input__inner  {
    height: 31px;
  }
 }

.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }

    .filter-area {
      margin:0 5px;
    }

    .filter-title {
      font-size: 12px;
      margin-right: 5px;
    }
  }

  .space {
    border-top: solid 1px #e0e0e0;
    padding: 5px 0;
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }

  .back {
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
